(function(){
  var el=document.getElementById('rx-dec-data'); if(!el)return;
  var X; try{X=JSON.parse(el.textContent)}catch(e){return}
  var di=-1,si=-1;
  (X.names||[]).forEach(function(n,i){ if(/d[ée]clench/i.test(n))di=i; else if(/[ée]tat/i.test(n))si=i });
  if(di<0||si<0)return;
  var root=document.querySelector('[data-bm]'); if(!root)return;
  var dj=root.querySelector('script[data-bm-data]'); if(!dj)return;
  var D; try{D=JSON.parse(dj.textContent)}catch(e){return}
  var by={}; X.variants.forEach(function(v){by[v.id]=v.o});
  (D.variants||[]).forEach(function(v){var o=by[v.id]; if(o)v.o=[o[di],'',o[si]]});
  dj.textContent=JSON.stringify(D);
  root.classList.add('rx-dec');
  var old=root.querySelector('[data-bm-cfgs]'); if(old){var og=old.closest('.bm-option-group'); if(og)og.remove()}
  var st=root.querySelector('[data-bm-states]'); if(!st)return;
  var sg=st.closest('.bm-option-group')||st.parentNode;
  var g=document.createElement('div'); g.className='bm-option-group bm-dec-group';
  g.innerHTML='<h2>Déclenchements</h2><div role="radiogroup" aria-label="Déclenchements" data-bm-cfgs></div><p class="bm-dec-note">Nombre de photos déjà prises par le boîtier (compteur d’obturateur), par tranche.</p>';
  sg.parentNode.insertBefore(g,sg.nextSibling);
})();
